import { Component, EventEmitter, HostListener, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { Contexto } from 'src/app/asistente-en-linea/models/contexto';
import { ArbolMenu } from '../../models/arbol-menu';
import { NodeType } from '../../models/node-type';
import { NodoArbolMenu } from '../../models/nodo-arbol-menu';
import { ArbolMenuHistorico } from '../../models/arbol-menu-historico';
import { MenuArbolService } from '../../services/menu-arbol.service';
import { environment } from 'src/environments/environment';
import { ConciergeService } from '../../../../services/concierge.service';
import { Subscription } from 'rxjs';
import { take } from 'rxjs/operators';
import { LocalStorageService } from 'src/app/asistente-en-linea/services/local-storage.service';
import { AuthService } from '../../../../../config/auth/auth.service';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmarAbrirVentanaDialogComponent } from './confirmar-abrir-ventana-dialog/confirmar-abrir-ventana-dialog.component';
import { PopupService } from '../../../../services/popup.service';
import { ContextoUrlService } from '../../../../services/contexto-url.service';
import { NavigationContextService } from '../../../../services/navigation-context.service';

declare function agregarEventoGoogleAnalytics(evento: any);
declare function eliminarUltimoEventoGoogleAnalytics();

@Component({
  selector: 'app-menu-arbol',
  templateUrl: './menu-arbol.component.html',
  styleUrls: ['./menu-arbol.component.scss']
})
export class MenuArbolComponent implements OnInit, OnDestroy {


  @Input() public ctx: Contexto;
  @Output() renderMenuArbolEmitter = new EventEmitter<Object>();
  @Output() nodeEmitter: EventEmitter<string>;
  @Output() displayAnswerEmitter: EventEmitter<NodoArbolMenu>;
  @Output() displayTramiteEmitter: EventEmitter<NodoArbolMenu>;

  cargandoDatos: boolean;
  arbolMenu: ArbolMenu;
  arbolMenuHistorico: ArbolMenuHistorico[];
  menusNodos: string[];
  currentFAQ: NodoArbolMenu[];
  faq: any;
  currentFather: NodoArbolMenu; //o currentRoute (la ruta hasta el nodo padre)
  currentFatherSinceNode: NodoArbolMenu;
  currentArbol: ArbolMenuHistorico;
  currentFatherOldMenu: NodoArbolMenu;
  displayCurrentFatherOldMenu: boolean;
  displayButtonReturnNode: boolean;
  temaCurrentFatherOldMenu: string;
  currentGrandparent: NodoArbolMenu;
  currentFatherNode: NodoArbolMenu;
  displayedNodes: NodoArbolMenu[]; //Los nodos que se mostrarán en en menú en el estado actual del programa.
  answerDisplayed: boolean;
  answerNode: NodoArbolMenu;
  temaActual: string;

  testVarToDisplayUrls: any;
  visiblePath: string;
  urlSitioAutenticar: string;
  maxPathLength: number = 100;
  subscriptionConcierge: Subscription;
  displayFormEmpresa: boolean;
  displayPieContactos: boolean;
  displayForm: boolean;
  displayTramite: boolean;
  displayMessenger: boolean;
  habilitado: boolean;
  cantidadNodos: number;
  numberOfSiblingsArr: number[];
  numberOfSiblingsArrCreation: number[];

  mostrarDiv = true;
  miValorVariable: string = 'Raiz';
  miValorVariablePadre: string = '';
  private popupRef: Window | null = null;

  constructor(private localstorage: LocalStorageService,
    public conciergeService: ConciergeService,
    private menuArbolService: MenuArbolService,
    private authService: AuthService,
    private contextoService: ContextoUrlService,
    private popupService: PopupService,
    private navigationContextService: NavigationContextService,
    private readonly dialog: MatDialog) {
    this.answerDisplayed = false;
    this.displayFormEmpresa = false;
    this.displayCurrentFatherOldMenu = false;
    this.displayButtonReturnNode = false;
    this.displayForm = true;
    this.displayTramite = false;
    this.displayMessenger = false;
    this.displayPieContactos = false;
    this.temaActual = "Declaración Nominada"
    this.arbolMenuHistorico = [];
    this.menusNodos = [];
    this.temaCurrentFatherOldMenu = '';
    this.nodeEmitter = new EventEmitter<string>();
    this.displayAnswerEmitter = new EventEmitter<NodoArbolMenu>();
    this.displayTramiteEmitter = new EventEmitter<NodoArbolMenu>();
    this.renderMenuArbolEmitter = new EventEmitter<Object>();
  }

  ngOnInit() {
    this.registrarEvento();
    this.loadArbolMenu(this.ctx.idMenu, this.ctx.idNodo);

    window.addEventListener('message', (event) => {
      if (event.data?.accion === 'cerrarPopup') {
        this.popupService.cerrarVentana(this.ctx.urlSitioAutenticar);
      }
    });
  }

  loadArbolMenu(idMenu, idNodo) {
    this.cargandoDatos = true;
    if(this.ctx.codAsistenteError != undefined) {
      this.answerDisplayed = false;
      this.displayForm = false;
      this.displayTramite = false;
      this.answerNode = undefined;
    }
    /** 
    console.log("answerDisplayed",this.answerDisplayed);
    console.log("displayForm",this.displayForm);
    console.log("displayTramite",this.displayTramite);
    console.log("answerNode",this.answerNode);
    **/
    this.menuArbolService.loadMenuArbolTree(idMenu, idNodo).subscribe((data: any) => {
      if (data && (data.statusCode == 200 || data.statusCode == 0)) {
        let jsonTree = data.content;
        this.habilitado = jsonTree.habilitado;
        let root = new NodoArbolMenu("ROOT", data.content.idMenu, "Raiz", undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, 0, jsonTree.faqs, undefined, data.content.descripcionMenu)
        let arbol = new ArbolMenu(root);
        this.arbolMenu = arbol.buildTree(jsonTree)

        if (!this.arbolMenuHistorico.some(item => item.idMenu === idMenu)) {
          this.currentArbol = new ArbolMenuHistorico(this.arbolMenu, idMenu, this.arbolMenu.root, this.currentFatherOldMenu);
          if (!this.arbolMenuHistorico.includes(this.currentArbol)) {
            this.arbolMenuHistorico.push(this.currentArbol);
          }
        }

        this.currentFather = this.arbolMenu.root;
        this.currentGrandparent = undefined;
        if (this.ctx.idNodo && this.currentFatherSinceNode == undefined) {
          this.currentFatherSinceNode = this.arbolMenu.search(this.ctx.idNodo);
          if (this.currentFatherSinceNode) {
            this.displayButtonReturnNode = false;
            this.currentFather = this.currentFatherSinceNode;
            this.currentGrandparent = this.arbolMenu.search(this.currentFather.parentId);
            switch (this.currentFather.type) {
              case NodeType.Action: {
                this.renderMenuArbolEmitter.emit({ idServicio: this.ctx.idServicio, codAsistente: this.currentFather.assistanceId, codigoTema: this.currentFather.areaCode, esFormulario: this.currentFather.esFormulario, codigoNodoArbol: this.currentFather.id.toString(), tipo: NodeType.Action, requiereAutenticacion: this.currentFather.requiereAutenticacion })
                break;
              }
              case NodeType.Form: {
                //this.renderMenuArbolEmitter.emit({ idServicio: this.ctx.idServicio, codAsistente: this.currentFather.assistanceId, codigoTema: this.currentFather.areaCode, esFormulario: this.currentFather.esFormulario, codigoNodoArbol: this.currentFather.id.toString() })
                this.renderMenuArbolEmitter.emit({ idServicio: this.ctx.idServicio, codAsistente: this.ctx.codAsistente, nodo: this.currentFather, tipo: NodeType.Form })
                break;
              }
              case NodeType.Chat: {
                // this.renderMenuArbolEmitter.emit({ idServicio: this.ctx.idServicio, codAsistente: this.currentFather.assistanceId, codigoTema: this.currentFather.areaCode, esFormulario: this.currentFather.esFormulario, codigoNodoArbol: this.currentFather.id.toString() })
                this.renderMenuArbolEmitter.emit({ idServicio: this.ctx.idServicio, codAsistente: this.ctx.codAsistente, nodo: this.currentFather, tipo: NodeType.Chat })
                break;
              }
              case NodeType.Tramite: {
                //this.renderMenuArbolEmitter.emit({ idServicio: this.ctx.idServicio, codAsistente: this.ctx.codAsistente, nodo: this.currentFather, tipo:NodeType.Tramite })
                //break;
                this.displayTramiteEmitter.emit(this.currentFatherSinceNode)
                this.answerNode = this.currentFatherSinceNode;
                this.answerDisplayed = true;
                this.displayTramite = true;
                this.currentFather = this.currentGrandparent;
                //this.displayAnswerTramite(this.currentFather);
                break;
              }
              case NodeType.Question: {
                this.nodeEmitter.emit(this.currentFather.id.toString());
                break;
              }
              case NodeType.Response: {
                this.displayAnswerEmitter.emit(this.currentFatherSinceNode)
                this.answerNode = this.currentFatherSinceNode;
                this.answerDisplayed = true;
                this.currentFather = this.currentGrandparent;
                break;
              }
              case NodeType.FAQ: {
                this.displayAnswerEmitter.emit(this.currentFather)
                break;
              }
            }
          }
        }
        if (!this.menusNodos.includes(this.ctx.idMenu)) {
          this.menusNodos.push(this.ctx.idMenu);
        }

        //if(!cargarDesdeNodo) {
        this.reloadTree();
        this.faq = jsonTree.menuFAQ;
        this.loadFAQ();
        //}



        this.updateVisiblePath();
        this.miValorVariable = this.currentFather.name !== "Raiz" ? this.currentFather.name : 'Raiz';
        this.miValorVariablePadre = this.currentFather.name !== "Raiz" && this.currentGrandparent ? this.currentGrandparent.name : '';
        this.showMessenger(this.currentFather);
        // Si tiene definido empresa verifica que venga instanciada. Si no viene no muestra el formulario
        if (this.ctx.formElements.datosEmpresa) {
          this.displayFormEmpresa = (this.ctx.datosEmpresa.nroEmpresa !== undefined);
        } else {
          this.displayFormEmpresa = true;
        }
        this.cargandoDatos = false;
      } else {
        this.ctx.errorCarga = true;
        this.ctx.mensajeErrorCarga = data.statusMessage;
        this.cargandoDatos = false;
      }
    },
      error => {
        this.ctx.errorCarga = true;
        if (error && error.status === 500) {
          this.ctx.mensajeErrorCarga = error.error?.statusMessage;
        }

        if (this.ctx.mensajeErrorCarga == undefined) {
          this.ctx.mensajeErrorCarga = "En este momento no podemos atenderlo debido a que estamos experimentando algunos problemas técnicos; por favor intente comunicarse con nosotros más tarde.";
        }

        this.cargandoDatos = false;
      })
  }

  showMessenger(obj) {
    this.displayMessenger = false;

    if (!this.ctx.errorCarga && obj.name === 'Raiz' && this.ctx.esEntornoAnonimo && this.ctx.historialMenus.length == 1) {
      this.displayMessenger = true;
    }
  }

  async irToStartNode() {
    this.currentFatherNode = undefined;
    this.currentFatherOldMenu = undefined;
    this.temaCurrentFatherOldMenu = undefined;
    this.displayCurrentFatherOldMenu = false;
    this.ctx.idMenu = this.ctx.historialMenus[0];
    this.ctx.historialMenus = [this.ctx.idMenu];
    this.menusNodos = [this.ctx.idMenu];
    this.arbolMenuHistorico = [];
    this.currentFatherSinceNode = undefined;
    this.answerDisplayed = false;
    this.answerNode = undefined;
    this.answerDisplayed = false;
    this.loadArbolMenu(this.ctx.idMenu, this.ctx.idNodo);
  }

  returnToStart() {
    this.ctx.codAsistenteError=undefined;
    this.ctx.esReporteError=false;
    if (this.arbolMenuHistorico.length > 1) {
      this.ctx.idMenu = this.ctx.historialMenus[0];
      this.ctx.historialMenus = [this.ctx.idMenu];
      const currentHist = this.arbolMenuHistorico[0];
      if (currentHist && currentHist.arbol) {
        this.arbolMenu = currentHist.arbol;
      }
    }

    this.currentFatherNode = undefined;
    this.currentFatherOldMenu = undefined;
    this.temaCurrentFatherOldMenu = undefined;
    this.displayCurrentFatherOldMenu = false;

    this.menusNodos = [this.ctx.idMenu];

    this.currentFather = this.arbolMenu.root;
    this.currentGrandparent = undefined;

    this.reloadTree();
    this.clearAnswerDisplayed()
    this.loadFAQ()
    this.updateVisiblePath()
    this.miValorVariable = 'Raiz';
    this.miValorVariablePadre = '';

    this.displayButtonReturnNode = false;
    if (this.currentFatherSinceNode) {
      this.displayButtonReturnNode = true;
    }
  }

  seleccionarNodo(event) {
    //debugger
    this.displayCurrentFatherOldMenu = false;

    this.displayButtonReturnNode = false;
    if (this.ctx.idNodo) {
      this.displayButtonReturnNode = true;
    }

    for (let nodo of this.displayedNodes) {
      if (nodo.id == event) {
        if (nodo.childs && nodo.childs.length > 0) {
          this.currentFather = nodo;
          if (this.ctx.idNodo && this.ctx.idNodo == nodo.parentId) {
            this.currentGrandparent = this.currentFatherNode;
          }
          if (this.menusNodos && this.menusNodos.length > 0 && this.menusNodos[this.menusNodos.length - 1] != nodo.menuId) {
            this.displayCurrentFatherOldMenu = true;
          }

          if (!this.menusNodos.includes(nodo.menuId)) {
            this.menusNodos.push(nodo.menuId);
          }
          // Eventos para google analytics
          let evento = {
            codAsistente: this.ctx.codAsistente,
            descServicio: this.ctx.descServicio,
            idAsistente: this.ctx.idAsistente,
            idServicio: this.ctx.idServicio,
            idNodo: nodo.id,
            idContenido: nodo.idContenido,
            nodoNombre: nodo.name
          }
          this.registrarEvento(evento);
          this.reloadTree();
          this.loadFAQ();
          this.updateVisiblePath();
          this.miValorVariable = this.currentFather.name;
          this.miValorVariablePadre = this.currentFather.name !== "Raiz" && this.currentGrandparent ? this.currentGrandparent.name : '';
        }
      }
    }

    if (this.currentFatherSinceNode && this.ctx.idNodo && this.ctx.idNodo != this.currentFather.id) {
      this.displayButtonReturnNode = true;
    }
  }
  sleep(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
  }
  async emitRenderMenuArbol(event) {
    this.cargandoDatos = true;
    this.displayCurrentFatherOldMenu = false;
    const idOldMenu = this.ctx.idMenu;
    this.registrarEvento(event.nodo);
    
    await new Promise<void>((resolve) => {
      this.renderMenuArbolEmitter.emit({ ...event, done: resolve });
    });
    //this.renderMenuArbolEmitter.emit(event);
    //await this.sleep(500);
    /**let idMenuNuevo = this.localstorage.getIdMenuAccion();
    let handlerAccion = this.localstorage.getHandlerAccionType();**/
    if (idOldMenu && idOldMenu != undefined && idOldMenu != this.ctx.idMenu) {
      if (this.currentFatherOldMenu) {
        this.temaCurrentFatherOldMenu = this.currentFatherOldMenu.name;
      } else {
        this.temaCurrentFatherOldMenu = this.currentFather.name;
      }
      this.currentFatherOldMenu = this.currentFather;
      this.displayCurrentFatherOldMenu = true;
      this.loadArbolMenu(this.ctx.idMenu, null);
      //this.menusNodos.push(this.ctx.idMenu);
    } else {
      this.cargandoDatos = false;
    }
  }


  loadFAQ() {
    this.currentFAQ = []
    for (let faq of this.currentFather.faqs) {
      let node = new NodoArbolMenu(
        undefined,
        undefined,
        faq.consulta,
        undefined,
        NodeType.FAQ,
        undefined,
        undefined,
        undefined,
        faq.respuesta,
        undefined,
        undefined,
        faq.codigoTemaDestinatario
      );
      this.currentFAQ.push(node);
    }

  }

  loadFAQTramite() {
    this.currentFAQ = []
    if (this.answerNode && this.answerNode.faqs) {
      for (let faq of this.answerNode.faqs) {
        let node = new NodoArbolMenu(
          undefined,
          undefined,
          faq.consulta,
          undefined,
          NodeType.FAQ,
          undefined,
          undefined,
          undefined,
          faq.respuesta,
          undefined,
          undefined,
          faq.codigoTemaDestinatario
        );
        this.currentFAQ.push(node);
      }
    }
  }

  reloadTree() {
    if (this.currentFather.id === "ROOT") {
      this.currentFatherNode = this.currentFather;
    }
    if (this.currentGrandparent == undefined && this.currentFatherOldMenu != undefined && this.arbolMenuHistorico) {
      for (let hist of this.arbolMenuHistorico) {
        if (this.currentFatherOldMenu.menuId == hist.idMenu) {
          this.currentGrandparent = hist.currentNode;
        }
      }
    }
    this.displayedNodes = this.sortNodes(this.currentFather.childs).filter(n => n.visible);
    //console.log(this.displayedNodes);
    this.displayForm = this.currentFather.idDestinatario !== undefined || (this.currentFather.assistanceId != undefined);
    this.displayPieContacto(this.currentFather);
    this.showMessenger(this.currentFather);
    this.currentGrandparent = this.currentFather?.parentId
      ? this.arbolMenu.search(this.currentFather.parentId)
      : undefined;
  }

  getTextoVolver() {
    if (!this.currentGrandparent) return 'Elegir otro tema de consulta';

    if (this.currentGrandparent.name === 'Raiz') {
      return 'Elegir otro tema de consulta';
    }

    return 'Volver a ' + this.currentGrandparent.name;
  }


  displayPieContacto(obj) {
    this.displayPieContactos = obj && obj.name !== 'Raiz'
    this.displayPieContactos = obj && obj.name !== 'Raiz'
    /**if(obj && obj.name !== 'Raiz') {
      const parent = this.arbolMenu.search(obj.parentId);
      this.displayPieContactos = obj && obj.name !== 'Raiz';
    }**/
  }
  displayAnswer(obj) {
    // Eventos para google analytics
    let evento = {
      codAsistente: this.ctx.codAsistente,
      descServicio: this.ctx.descServicio,
      idAsistente: this.ctx.idAsistente,
      idServicio: this.ctx.idServicio,
      idNodo: obj.id,
      idContenido: obj.idContenido,
      nodoNombre: obj.name
    }
    this.displayTramite = false;
    this.answerNode = obj;
    this.registrarEvento(evento);
    
    if (this.answerNode.assistanceId) {
      this.cargandoDatos = true;
      const node = this.answerNode;
      this.clearAnswerDisplayedNode();
      this.emitRenderMenuArbol({ idServicio: this.ctx.idServicio, codAsistente: this.ctx.codAsistente, nodo: node, tipo: NodeType.Action });
    } else {
      this.displayForm = (this.answerNode.idDestinatario !== undefined) || (this.answerNode.assistanceId !== undefined);
      // this.generateHTMLLinks(this.answerNode.answer);
      this.answerDisplayed = true;
      this.displayButtonReturnNode = false;
      if (this.currentFatherSinceNode && this.ctx.idNodo && this.ctx.idNodo != this.answerNode.id) {
        this.displayButtonReturnNode = true;
      }
      this.miValorVariable = this.answerNode.name;
      this.miValorVariablePadre = this.currentFather.name !== "Raiz" ? this.currentFather.name : '';

      this.displayPieContacto(obj);
      this.showMessenger(obj);
    }
  }

  displayAnswerTramite(obj) {
    // Eventos para google analytics
    let evento = {
      codAsistente: this.ctx.codAsistente,
      descServicio: this.ctx.descServicio,
      idAsistente: this.ctx.idAsistente,
      idServicio: this.ctx.idServicio,
      idNodo: obj.id,
      idContenido: obj.idContenido,
      nodoNombre: obj.name
    }
    this.registrarEvento(evento);
    this.answerNode = obj;
    this.displayForm = false;
    this.displayTramite = false;
    if (this.answerNode.idContenido !== undefined || this.answerNode.idDestinatario !== undefined || (this.answerNode.assistanceId !== undefined)) {
      this.displayTramite = true;
    }
    //this.habilitado = true;

    // this.generateHTMLLinks(this.answerNode.answer);
    this.answerDisplayed = true;
    this.displayButtonReturnNode = false;
    if (this.currentFatherSinceNode && this.ctx.idNodo && this.ctx.idNodo != this.answerNode.id) {
      this.displayButtonReturnNode = true;
    }
    this.miValorVariable = this.answerNode.name;
    this.miValorVariablePadre = this.currentFather.name !== "Raiz" ? this.currentFather.name : '';
    this.displayPieContacto(obj);
    this.showMessenger(obj);
    this.loadFAQTramite();
    // console.log("this.currentFAQ",this.currentFAQ);
  }

  clearAnswerDisplayedNode() {
    this.displayTramite = false;
    this.currentFAQ = [];
    this.answerNode = undefined;
    this.answerDisplayed = false;
    this.displayForm = false;
    this.displayButtonReturnNode = false;
    if (this.currentFatherSinceNode && this.ctx.idNodo && this.ctx.idNodo != this.currentFather.id) {
      this.displayButtonReturnNode = true;
    }
    this.displayForm = this.currentFather && (this.currentFather.idDestinatario !== undefined || this.currentFather.assistanceId !== undefined);
    this.displayPieContacto(this.currentFather);
    this.showMessenger(this.currentFather);
    this.loadFAQ();
    eliminarUltimoEventoGoogleAnalytics();
    //this.habilitado = true;
    //this.displayForm = this.currentFather &&  ((this.currentFather.areaCode !== undefined) && (this.currentFather.areaCode !== '') && this.currentFather.conDestinatario);
  }



  clearAnswerDisplayed() {
    this.displayTramite = false;
    this.currentFAQ = [];
    this.answerNode = undefined;
    this.answerDisplayed = false;
    this.displayCurrentFatherOldMenu = false;

    if (this.menusNodos && this.menusNodos.length > 1
      && ((this.menusNodos[this.menusNodos.length - 1] == this.currentFather.menuId)
        && (this.currentFather.name == 'Raiz' && this.currentFather.id == 'ROOT'))) {
      this.displayCurrentFatherOldMenu = true;
      this.menusNodos.pop();
    }

    this.displayButtonReturnNode = false;
    if (this.currentFatherSinceNode && this.ctx.idNodo && this.ctx.idNodo != this.currentFather.id) {
      this.displayButtonReturnNode = true;
    }
    this.displayForm = this.currentFather && (this.currentFather.idDestinatario !== undefined || this.currentFather.assistanceId !== undefined);
    //this.habilitado = true;
    //this.displayForm = this.currentFather &&  ((this.currentFather.areaCode !== undefined) && (this.currentFather.areaCode !== '') && this.currentFather.conDestinatario);
    this.miValorVariable = this.currentFather.name;
    this.miValorVariablePadre = this.currentFather.name !== "Raiz" && this.currentGrandparent ? this.currentGrandparent.name : '';
    this.displayPieContacto(this.currentFather);
    this.showMessenger(this.currentFather);
    this.loadFAQ();
    eliminarUltimoEventoGoogleAnalytics();
  }

  sortNodes(nodes: NodoArbolMenu[]) {
    let sorted = nodes ? nodes.sort((a, b) => {
      return a.order - b.order;
    }) : [];
    return sorted;
  }

  irAlTramite() {
    if (this.answerNode.idContenido) {
      let evento = {
        codAsistente: this.ctx.codAsistente,
        descServicio: this.ctx.descServicio,
        idAsistente: this.ctx.idAsistente,
        idServicio: this.ctx.idServicio,
        idNodo: this.answerNode.id,
        idContenido: this.answerNode.idContenido,
        nodoNombre: this.answerNode.name
      }
      this.registrarEvento(evento);
      let urlUrlTramites = this.ctx.urlSitioBps;
      if (!urlUrlTramites.endsWith('/')) {
        urlUrlTramites = urlUrlTramites + '/';
      }
      window.open(urlUrlTramites + this.answerNode.idContenido + '/', '_blank');
    }
  }

  abrirVentanaCentrada(nodo) {
    if (nodo) {
      let urlUrlSitio = this.ctx.urlSitioAutenticar;
      if (!urlUrlSitio.endsWith('/')) {
        urlUrlSitio = urlUrlSitio + '/';
      }
      urlUrlSitio = urlUrlSitio + '?idNodo=' + nodo.id + '&open=true&hideAllButtonsForm=true&goInside=true&fromAnonymous=true';
      if (this.ctx.idServicio) {
        urlUrlSitio = urlUrlSitio + "&idServicio=" + this.ctx.idServicio;
      }
      this.navigationContextService.addNode(nodo.id);
      const ids = this.navigationContextService.getIds();
      if(ids && ids.length > 0) {
        urlUrlSitio = urlUrlSitio + "&ids=" + this.navigationContextService.getIds();
      }
      urlUrlSitio = urlUrlSitio + "&contexto=" + this.contextoService.encode(this.contextoService.getParentUrlSafely());
      this.popupService.abrirVentana(urlUrlSitio, "Alisse", 600, 750);
      this.popupService.abrirVentana(urlUrlSitio + '?idNodo=' + nodo.id + '&open=true&hideAllButtonsForm=true&goInside=true', "Alisse", 600, 750);
    }
  }

  cargarFormularioConsulta() {
    let nodoProcesar;
    let mostrarVentana = false;
    if (this.ctx.esEntornoAnonimo) {
      if (this.answerNode) {
        nodoProcesar = this.answerNode;
        if (nodoProcesar.requiereAutenticacion) {
          mostrarVentana = true;
        }
      } else {
        nodoProcesar = this.currentFather;
        if (nodoProcesar.requiereAutenticacion) {
          mostrarVentana = true;
        }
      }
    }

    if (mostrarVentana) {
      this.abrirVentanaCentrada(nodoProcesar);
    } else {
      this.cargarConsulta();
    }
  }
  async cargarConsulta() {
    // Antes de cargar el formulario se guarda el historico de navegacion (desde donde partio la llamada al formulario)
    this.ctx.navigationHistory.codAsistente = this.ctx.codAsistente;
    this.ctx.navigationHistory.idServicio = this.ctx.idServicio;
    this.ctx.navigationHistory.idMenu = this.ctx.idMenu;
    this.ctx.navigationHistory.idFormAsociado = this.ctx.idFormAsociado;

    if (this.answerNode && (this.answerNode.type === 'RESPUESTA' || this.answerNode.type === 'TRAMITE' || this.answerNode.type === 'FAQ')) {
      //this.ctx.etiquetaTema = this.answerNode.name;
      this.ctx.etiquetaNodoArbol = this.answerNode.name;
      this.ctx.idNodo = this.answerNode.id;

      if (this.answerNode.type === 'TRAMITE' && this.answerNode.assistanceId) {
        this.cargandoDatos = true;
        const node = this.answerNode;
        this.registrarEvento(node);
        this.clearAnswerDisplayedNode();
        this.emitRenderMenuArbol({ idServicio: this.ctx.idServicio, codAsistente: this.ctx.codAsistente, nodo: node, tipo: NodeType.Action });
      } else {
        this.renderMenuArbolEmitter.emit({ idServicio: this.ctx.idServicio, codAsistente: this.ctx.codAsistente, nodo: this.answerNode, tipo: NodeType.Form })
      }
    } else {
      // Se asigna el nombre del nodo a la etiqueta par que despliegue el formulario de consulta
      this.ctx.codigoNodoArbol = this.currentFather.id;
      this.ctx.etiquetaNodoArbol = this.currentFather.name;

      if (this.currentFather.type === 'PREGUNTA' && this.currentFather.assistanceId) {
        this.registrarEvento(this.currentFather);
        this.clearAnswerDisplayedNode();
        this.emitRenderMenuArbol({ idServicio: this.ctx.idServicio, codAsistente: this.ctx.codAsistente, nodo: this.currentFather, tipo: NodeType.Action });
      } else {
        this.renderMenuArbolEmitter.emit({ idServicio: this.ctx.idServicio, codAsistente: this.ctx.codAsistente, nodo: this.currentFather, tipo: NodeType.Form })
      }

    }
  }

  loadParentOldMenu() {
    this.displayForm = false;
    this.displayCurrentFatherOldMenu = false;
    //this.temaCurrentFatherOldMenu = '';
    let historico = [];
    let idMenuHist = [];
    for (let hist of this.arbolMenuHistorico) {
      if (this.ctx.idMenu != hist.idMenu) {
        if (!idMenuHist.includes(hist.idMenu)) {
          historico.push(hist);
          idMenuHist.push(hist.idMenu);
        }
      }
    }
    for (let hist of this.arbolMenuHistorico) {
      if (this.currentFatherOldMenu.menuId == hist.idMenu) {
        const beforeHist = this.arbolMenuHistorico.find(c => c.idMenu == this.ctx.obtenerMenuAnterior());
        if (beforeHist) {
          this.arbolMenu = beforeHist.arbol;
        } else {
          this.arbolMenu = hist.arbol;
        }
        const currentHist = this.arbolMenuHistorico.find(c => c.idMenu == this.ctx.obtenerMenuActual());
        if (currentHist && currentHist.oldNodoArbolMenu) {
          this.currentFather = currentHist.oldNodoArbolMenu;
        } else {
          this.currentFather = hist.currentNode;
        }


        //this.currentGrandparent = this.arbolMenu.search(this.currentFather.parentId);
        this.reloadTree();
        this.clearAnswerDisplayed();
        this.loadFAQ();
        this.updateVisiblePath();
        if (idMenuHist.length == 1) {
          this.ctx.idMenu = idMenuHist[0];
        } else {
          this.ctx.idMenu = hist.idMenu;
        }

        this.ctx.historialMenus = idMenuHist;
        this.arbolMenuHistorico = historico;
        this.displayCurrentFatherOldMenu = true;
        if (this.arbolMenuHistorico.length > 1) {
          this.currentFatherOldMenu = hist.currentNode;
          this.displayCurrentFatherOldMenu = true;
        } else {
          this.currentFatherOldMenu = undefined;
          this.displayCurrentFatherOldMenu = false;
        }
        break;
      }
    }
  }

  loadParent() {
    //Crear método en el árbol para hacer búsqueda.
    if (this.currentFatherNode && this.ctx.idNodo && this.ctx.idNodo == this.currentFather.parentId) {
      this.currentFather = this.currentFatherNode;
      this.currentGrandparent = this.currentFatherNode;
    } else {
      this.currentFather = this.arbolMenu.search(this.currentFather.parentId);
      this.currentGrandparent = this.arbolMenu.search(this.currentFather.parentId);
    }

    this.reloadTree();
    this.clearAnswerDisplayed();
    this.loadFAQ();
    this.updateVisiblePath();
    this.miValorVariable = this.currentFather.name;
    this.miValorVariablePadre = this.currentFather.name !== "Raiz" && this.currentGrandparent ? this.currentGrandparent.name : '';
  }

  //Slicing del path para que no quede muy largo
  updateVisiblePath() {
    if (this.currentFather.id === "ROOT") {
      return;
    }
    if (this.currentFather.path.length > this.maxPathLength) {
      let split = this.currentFather.path.split(">")
      let i = split.length - 1;
      let aux = "";
      while (i > 0) {
        if (aux.length + split[i].length > this.maxPathLength) {
          break;
        }
        if (i !== split.length - 1) {
          aux = split[i] + ">" + aux;
        }
        else { aux = split[i] }
        i--;
      }
      aux = aux === "" ? split[i] : aux;
      this.visiblePath = "... " + aux;
    }
    else {
      this.visiblePath = this.currentFather.path;
    }

  }

  updateGrandparent() {

  }

  @HostListener('window:beforeunload', ['$event'])
  beforeUnloadHandler(event: Event) {
  }

  @HostListener('window:unload', ['$event'])
  unloadHandler(event: Event) {
  }

  ngOnDestroy(): void {
  }

  obtenerEtiquetaVolver() {
    let etiqueta = "Volver a " + (this.currentFather ? this.currentFather.name : "Inicio");
    if (this.currentFather && this.currentFather.name == "Raiz") {
      etiqueta = "Volver";
    }
    return etiqueta;
  }

  abrirMessenger() {
    window.open('https://m.me/BPSuy?ref=site', "_blank");
  }

  registrarEvento(nodo?: any) {
    let evento = nodo;
    // Si no recibe nodo, es porque es el principal
    if (typeof evento == "undefined") {
      evento = {
        codAsistente: this.ctx.codAsistente,
        descServicio: this.ctx.descServicio,
        idAsistente: this.ctx.idAsistente,
        idServicio: this.ctx.idServicio
      }
    }
    agregarEventoGoogleAnalytics(evento);
  }

  displayAnswerEnlace(obj) {
    // Eventos para google analytics
    let evento = {
      codAsistente: this.ctx.codAsistente,
      descServicio: this.ctx.descServicio,
      idAsistente: this.ctx.idAsistente,
      idServicio: this.ctx.idServicio,
      idNodo: obj.id,
      idContenido: obj.idContenido,
      nodoNombre: obj.name
    }
    this.registrarEvento(evento);
    if (obj.url) {
      window.open(obj.url, '_blank');
    } else {
      console.warn('Nodo tipo Enlace sin URL:', obj);
    }

  }
}

